module.exports = __webpack_public_path__ + "img/HA02.9ed225c1.jpg";